/* GENERATED from pdp-review-summary.src.js by build/gen_js.py - do not edit.
   The commented source is pdp-review-summary.src.js. */
(function () {
'use strict';
if (!document.querySelector('.pdpage')) return;
var selector = '.pdpage .fera-productReviews-widget .fera-review-body';
var pending = false;
function enhance() {
pending = false;
document.querySelectorAll('.pdpage .fera-productReviews-widget h1[data-fera-widget-heading]').forEach(function (heading) {
var h2 = document.createElement('h2');
Array.from(heading.attributes).forEach(function (attr) { h2.setAttribute(attr.name, attr.value); });
while (heading.firstChild) h2.append(heading.firstChild);
heading.replaceWith(h2);
});
document.querySelectorAll(selector).forEach(function (body) {
if (body.closest('[data-review-preview]')) return;
var details = document.createElement('details');
var summary = document.createElement('summary');
var more = document.createElement('span');
var less = document.createElement('span');
details.setAttribute('data-review-preview', '');
body.setAttribute('data-review-body', '');
more.setAttribute('data-review-more', '');
less.setAttribute('data-review-less', '');
more.textContent = 'Read more';
less.textContent = 'Read less';
body.before(details);
summary.append(body, more, less);
details.append(summary);
});
}
function schedule() {
if (pending) return;
pending = true;
requestAnimationFrame(enhance);
}
new MutationObserver(function (records) {
if (records.some(function (record) {
return record.target.nodeType === 1 && record.target.closest('.fera-productReviews-widget') ||
Array.from(record.addedNodes).some(function (node) {
return node.nodeType === 1 && (node.matches('.fera-productReviews-widget') || node.querySelector('.fera-productReviews-widget'));
});
})) schedule();
}).observe(document.querySelector('.pdpage'), { childList: true, subtree: true });
enhance();
})();
